import React from 'react'
import styles from './SearchableMultiSelect.scss'
import {Panel} from './Panel'
import {Map, Set} from 'immutable'
import p from 'prop-types'
import cx from 'classnames'

export class SearchableMultiSelect extends React.PureComponent {
  static propTypes = {
    options: p.instanceOf(Map).isRequired,
    selectedIds: p.instanceOf(Set).isRequired,
    valueAttr: p.string // string name of attribute to use in formatting
  }

  static defaultProps = {
    valueAttr: 'name'
  }

  constructor (props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  componentWillUpdate () {
    document.addEventListener('mousedown', this.handleDocumentClick)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleDocumentClick)
  }

  handleDocumentClick = (e) => {
    if (this.wrapper && !this.wrapper.contains(e.target)) {
      this.setState({expanded: false})
    }
  }

  formatSelected = () => {
    const {options, selectedIds, valueAttr} = this.props
    if (selectedIds.size === 0) return 'None Selected'

    const names = options.filter(o => selectedIds.has(o.id)).map(o => o[valueAttr])
    return names.join(', ')
  }

  inputClicked = () => {
    if (this.state.expanded) return
    this.setState({expanded: true})
  }

  render () {
    const {
      options,
      selectedIds,
      onSelectedIdsChange,
      valueAttr,
      newRecordString,
      dispatchCreate,
      createNewPending,
      showSpinner
    } = this.props
    const {expanded} = this.state

    return (
      <div className={cx(styles.SearchableMultiSelect, expanded && styles.expandedInput)}
        onClick={() => this.inputClicked()}
        ref={ref => { this.wrapper = ref }}>
        {expanded
          ? <Panel
            options={options}
            selectedIds={selectedIds}
            onSelectedIdsChange={onSelectedIdsChange}
            valueAttr={valueAttr}
            newRecordString={newRecordString}
            dispatchCreate={dispatchCreate}
            showSpinner={showSpinner}
            createNewPending={createNewPending}
            collapsePanel={() => this.setState({expanded: false})} />
          : this.formatSelected()}
      </div>
    )
  }
}
